import React from "react";
import ReactDOM from "react-dom/client";
import "assets/scss/material-dashboard-pro-react.scss?v=1.9.0";
import * as serviceWorker from "./helpers/serviceWorker";
import UserService from "./services/UserService";
import HttpService from "./services/HttpServices";
import { lightTheme } from "./styles/theme";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
  useRouteError,
} from "react-router-dom";
import AdminLayout from "./layouts/Admin";
// import { ThemeProvider } from "styled-components";
import { ThemeProvider as ThemeProviderV5 } from '@mui/material';
import { createBrowserHistory } from "history";
import { createTheme as createThemeV5 } from '@mui/material';
import Home from "views/Home/Home.js";
import routes from "routes.js";
import routesNoMenu from "routesnomenu.js";
import { getAllowedRoutes } from "helpers/GetAllowedRoutes";
// import './MuiClassNameSetup';
import { StyledEngineProvider } from '@mui/material/styles';
import { isMobile } from "react-device-detect"; // optionnel, pratique
import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey('213028fda2d9230a09dabff45a34ab2eTz0xMjI2ODgsRT0xNzk2NDI4Nzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');

let errorcount = 0;

function ErrorBoundary() {
  let error = useRouteError();
  console.error(errorcount);
  console.error(error);
  if (errorcount < 3) {
    errorcount++;
    setTimeout(() => {
      console.error('reload');
      window.location.reload();
    }, 500);
  }
  else
    return <div></div>;
}

const fullroutes = getAllowedRoutes(routesNoMenu.concat(routes));
const router =  createBrowserRouter([
  {
    path: "/admin",
    errorElement: <ErrorBoundary />,
    element: <AdminLayout />,
    children: fullroutes.map((e, k) => {
      return {
        path: e.layout + e.path,
        element: <e.component />
      }
    })
  },
  {
    errorElement: <ErrorBoundary />,
    path: "/",
    element: <Navigate to="/admin/home" replace />
  }
]);


// const mobileRouter =  createBrowserRouter([
//   {
//     path: "/admin",
//     errorElement: <ErrorBoundary />,
//     element: <AdminLayout />,
//     children: fullroutes.map((e, k) => {
//       return {
//         path: e.layout + e.path,
//         element: <e.component />
//       }
//     })
//   },
//   {
//     errorElement: <ErrorBoundary />,
//     path: "/",
//     element: <h1>Accueil Mobile</h1>
//   }
// ]);

// const router = isMobile ? mobileRouter : desktopRouter;

const themeV5 = createThemeV5({
  palette: {
    primary: {
      main: '#000000',
    },
  },
});

const hist = createBrowserHistory();

// const generateClassName = createGenerateClassName({
//   // By enabling this option, if you have non-MUI elements (for example `<div />`)
//   // using MUI classes (for example `.MuiButton`) they will lose styles.
//   // Make sure to convert them to use `styled()` or `<Box />` first.
//   disableGlobal: true,
//   // Class names will receive this seed to avoid name collisions.
//   seed: 'mui-jss',
// });

const root = ReactDOM.createRoot(document.getElementById("root"));
const renderApp = () => root.render(
  // <React.StrictMode>
  <StyledEngineProvider injectFirst>
    <ThemeProviderV5 theme={themeV5}>
      <RouterProvider router={router} />
    </ThemeProviderV5>
  </StyledEngineProvider>
  // </React.StrictMode>
);

// root.render(
//   // <React.StrictMode>

//     <ThemeProviderV5 theme={themeV5}>
//       <RouterProvider router={router} />
//     </ThemeProviderV5>

//   // </React.StrictMode>
// )

// const renderApp = () =>
//   ReactDOM.render(

//         <ThemeProviderV5 theme={themeV5}>
//           <Router history={hist}>
//             <Routes>
//               <Route path="/admin" element={AdminLayout} />
//               <Navigate from="/" to="/admin/home" />
//             </Routes>
//           </Router>
//         </ThemeProviderV5>,
//     document.getElementById("root")
//   );

UserService.initKeycloak(renderApp);
HttpService.configure();

//HttpService.configure();
// If we want our app to work offline and load faster, we can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
